var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotjar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8185 13.6888C17.2808 12.3232 20.6559 10.4482 20.6559 5H16.5732C16.5732 8.04958 15.0874 8.87743 12.8373 10.1227C10.375 11.4883 7 13.3634 7 18.8116H11.0826C11.0826 15.762 12.5685 14.9342 14.8185 13.6888Z",
    fill: "#E73C1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8862 12.4375C21.8862 15.4871 20.4003 16.3149 18.1503 17.5602C15.688 18.9258 12.313 20.8009 12.313 26.2491H16.3956C16.3956 23.1995 17.8815 22.3716 20.1315 21.1263C22.5938 19.7607 25.9688 17.8857 25.9688 12.4375H21.8862Z",
    fill: "#E73C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotjar);
export default __webpack_public_path__ + "static/media/Hotjar.f9371cb38e7474bcf5bd74f4970b91b4.svg";
export { ForwardRef as ReactComponent };